'use strict';

angular.module('portal.inspections')
    .controller('PortalInspection', ['$scope', 'Cache', '$stateParams', '$q', '$timeout', '$uibModal', '$state', '$rootScope', 'Documents', 'Session',
        function ($scope, Cache, $stateParams, $q, $timeout, $uibModal, $state, $rootScope, Documents, Session) {

            $scope.loading = true;
            $scope.saving = false;
            $scope.notInCache = false;
            $scope.inspectionID = $stateParams.id;
            $scope.inspection = $stateParams.inspection;
            $scope.showSaved = false;
            $scope.validationSuccess = false;
            $scope.validationMessage = null;
            $scope.checklist = {};
            $scope.checklistForm = {};
            $scope.deficiencyScore = { score: 0 };
            $scope.deficiencies = {
                fail: 0,
                pass: 0,
                ignore: 0
            }
            $scope.documents = [];

            // Check if signature is required based on template settings
            $scope.isSignatureRequired = function () {
                return $scope.inspection &&
                    $scope.inspection.checklist &&
                    $scope.inspection.checklist.template &&
                    $scope.inspection.checklist.template.require_responsible_party_signature &&
                    $scope.inspection.checklist.signature_type_in_person === true;
            };

            // Check if the signature pad is empty
            $scope.isSignatureEmpty = function () {
                // Check if signature pad exists and has the _isEmpty flag set to false
                if ($scope.checklistForm && $scope.checklistForm.signature && $scope.checklistForm.signature._isEmpty === false) {
                    return false; // Has signature data
                }

                // Check if signature photo source exists and has data
                if ($scope.inspection && $scope.inspection.checklist && $scope.inspection.checklist.signature_photo_source) {
                    return false; // Has signature data
                }

                return true; // No signature data found
            };

            // Validate form including signature if required (only for final validation, not for saving)
            $scope.isFormValid = function (the_form, inspection) {
                var valid = the_form.$valid;

                // Only validate signature if it's required and signature type is in-person
                if (inspection && inspection.checklist && inspection.checklist.template &&
                    inspection.checklist.template.require_responsible_party_signature &&
                    inspection.checklist.signature_type_in_person === true) {

                    // Check if we have a signature pad reference
                    if ($scope.checklistForm && $scope.checklistForm.signature) {
                        // Signature pad exists - check if it's empty
                        if ($scope.checklistForm.signature.isEmpty()) {
                            valid = false;
                        } else {
                            valid = true;
                        }
                    }
                    // Check if we have saved signature data
                    else if (inspection.checklist.signature_photo_source) {
                        valid = true;
                    }
                    else {
                        valid = false;
                    }
                }

                return valid;
            };

            // Clear the signature pad canvas
            $scope.clearSignaturePad = function () {
                if ($scope.checklistForm && $scope.checklistForm.signature) {
                    // Clear the signature pad
                    $scope.checklistForm.signature.clear();

                    // Set the _isEmpty flag
                    $scope.checklistForm.signature._isEmpty = true;

                    // Clear the model
                    $scope.inspection.checklist.signature_photo_source = null;

                    // Clear validation error
                    if ($scope.the_form && $scope.the_form.signatureField) {
                        $scope.the_form.signatureField.$setValidity('required', true);
                        $scope.the_form.signatureField.$setPristine();
                        $scope.the_form.signatureField.$setUntouched();
                    }
                }
            };

            $scope.save = function (the_form) {
                Session.checkIn();
                $scope.saving = true;
                $scope.validationMessage = null;
                $scope.validationSuccess = false;
                $scope.showSaved = false;

                // Don't validate signature for save - just validate the form fields
                $scope.inspection.checklist.isFormValid = the_form.$valid;

                $scope.saveInspection($scope.inspection, $scope.checklist, $scope.deficiencies).then(function () {
                    //make the saving spinner stay for a bit, otherwise it's so fast you can't even see it
                    var saveTimeout = $timeout(function () {
                        $scope.saving = false;
                        $scope.showSaved = true;
                    }, 500);

                    if ($scope.inspection.checklist.isFormValid && !$scope.isSignatureRequired()) {
                        $scope.validationMessage = "All required information has been supplied";
                        $scope.validationSuccess = true;
                    }
                    else if ($scope.inspection.checklist.isFormValid && $scope.isSignatureRequired() && !$scope.isSignatureEmpty()) {
                        $scope.validationMessage = "All required information has been supplied";
                        $scope.validationSuccess = true;
                    }
                    else {
                        $scope.validationMessage = "Checklist saved, but required information is missing";
                        $scope.validationSuccess = false;
                    }

                    var validationTimeout = $timeout(function () {
                        $scope.validationMessage = null;
                        $scope.validationSuccess = false;
                        $scope.showSaved = false;
                    }, 3000);

                    $scope.$on('$destroy', function () {
                        $timeout.cancel(saveTimeout);
                        $timeout.cancel(validationTimeout);
                    });
                })
            }

            $scope.saveAndExit = function (the_form) {
                $scope.saving = true;
                $scope.validationMessage = null;
                $scope.validationSuccess = false;
                $scope.showSaved = false;

                // Don't validate signature for save - just validate the form fields
                $scope.inspection.checklist.isFormValid = the_form.$valid;

                $scope.saveInspection($scope.inspection, $scope.checklist, $scope.deficiencies).then(function () {
                    // Always allow save and exit, but show warning if form is incomplete
                    if (!$scope.inspection.checklist.isFormValid || ($scope.isSignatureRequired() && $scope.isSignatureEmpty())) {
                        $uibModal.open({
                            animation: true,
                            templateUrl: 'templates/confirm/confirm.html',
                            controller: 'ConfirmModalController',
                            resolve: {
                                message: function () {
                                    return "Required fields are missing. Do you still want to leave?";
                                }
                            }
                        }).result.then(function (result) {
                            if (result) {
                                var timer = $timeout(function () {
                                    $scope.saving = false;
                                    $state.go('portal.menus.inspections');
                                }, 100);
                                $scope.$on('$destroy', function () {
                                    $timeout.cancel(timer);
                                });
                            }
                            else {
                                $scope.saving = false;
                            }
                        }, function () {
                            $scope.saving = false;
                        });
                    }
                    else {
                        var timer = $timeout(function () {
                            $scope.saving = false;
                            $state.go('portal.menus.inspections');
                        }, 100);
                        $scope.$on('$destroy', function () {
                            $timeout.cancel(timer);
                        });
                    }
                });
            }

            $scope.saveInspection = function (inspection, checklist, deficiencies) {
                var d = $q.defer();

                // Convert signature pad to data URL if available and not empty
                if ($scope.checklistForm.signature != null && !$scope.checklistForm.signature.isEmpty()) {
                    inspection.checklist.signature_photo_source = $scope.checklistForm.signature.toDataURL();
                    inspection.checklist.checklist_signed = true;
                }
                // Clear signature if empty
                else if ($scope.isSignatureEmpty()) {
                    inspection.checklist.signature_photo_source = null;
                    inspection.checklist.checklist_signed = false;
                }

                inspection.checklist.deficiencies_fail = deficiencies.fail;
                inspection.checklist.deficiencies_pass = deficiencies.pass;
                inspection.checklist.deficiencies_ignore = deficiencies.ignore;

                if (!$scope.complete() || !$scope.failed()) {
                    inspection.reinspect = false;
                }
                if ($scope.complete()) {
                    inspection.outcome = !$scope.failed();
                }
                else {
                    inspection.outcome = null;
                }
                inspection.inspector_id = $rootScope.userAccount.inspector_id;
                inspection.inspector = {
                    id: $rootScope.userAccount.inspector_id,
                    name: $rootScope.userAccount.name
                }
                inspection.submitted = false;

                var inspectionStr = JSON.parse(JSON.stringify(inspection));
                Cache.save('inspection', inspectionStr).then(function () {
                    d.resolve();
                });

                return d.promise;
            }

            $scope.complete = function () {
                // This hasn't changed with the addition of scoring (170495). We can still use this to determine completeness even if it's being evaluated based on score.
                return $scope.deficiencies.fail + $scope.deficiencies.pass + $scope.deficiencies.ignore == $scope.inspection.checklist.template.deficiencies_total;
            }

            $scope.failed = function () {
                if ($scope.inspection.checklist.template.passing_score_type) {
                    return $scope.inspection.checklist.template.passing_score > $scope.deficiencyScore.score;
                }
                else {
                    return $scope.deficiencies.fail >= $scope.inspection.checklist.template.auto_fail;
                }
            }

            Cache.get('inspection', $stateParams.id).then(function (inspection) {
                if (inspection != null) {
                    $scope.inspection = inspection;
                    $scope.deficiencies.fail = inspection.checklist.deficiencies_fail != null ? inspection.checklist.deficiencies_fail : 0;
                    $scope.deficiencies.pass = inspection.checklist.deficiencies_pass != null ? inspection.checklist.deficiencies_pass : 0;
                    $scope.deficiencies.ignore = inspection.checklist.deficiencies_ignore != null ? inspection.checklist.deficiencies_ignore : 0;
                    $scope.passingChecklist = $scope.inspection.checklist.template;
                    $scope.passingChecklist.inspectionID = $scope.inspectionID;

                    if (inspection.checklist) { $scope.checklist = angular.copy(inspection.checklist); }

                    if ($scope.inspection.reinspection_date == null) {
                        $scope.inspection.reinspection_date = new Date();
                        $scope.inspection.reinspection_date.setHours(0, 0, 0, 0);
                        if ($scope.inspection.checklist.template.reinspection != null) {
                            $scope.inspection.reinspection_date.setDate($scope.inspection.reinspection_date.getDate() + $scope.inspection.checklist.template.reinspection);
                        }
                    }

                    if ($scope.inspection.checklist.template.require_responsible_party_signoff === true && ($scope.inspection.checklist.signature_type_in_person === null || $scope.inspection.checklist.signature_type_in_person === undefined)) {
                        $scope.inspection.checklist.signature_type_in_person = true;
                    }

                    $scope.loading = false;
                }
                else {
                    console.log('Inspection is not in cache');
                    $scope.loading = false;
                    $scope.notInCache = true;
                }
            });

            // Hook into signature pad to clear validation when user draws
            var unwatchCanvas = $scope.$watch(function () {
                return document.querySelector('.sig.sigWrapper canvas');
            }, function (canvas) {
                if (canvas) {
                    unwatchCanvas();

                    $timeout(function () {
                        var canvasElement = angular.element(canvas);
                        // Access the isolated scope created by ng-signature-pad directive
                        var isolatedScope = canvasElement.isolateScope() || canvasElement.scope();

                        if (isolatedScope && isolatedScope.ngSignaturePad) {
                            var signaturePad = isolatedScope.ngSignaturePad;

                            // Store reference in checklistForm for easy access
                            $scope.checklistForm.signature = signaturePad;

                            var originalOnEnd = signaturePad.onEnd;

                            // Override onEnd to update model and clear validation after each stroke
                            signaturePad.onEnd = function () {
                                if (originalOnEnd && typeof originalOnEnd === 'function') {
                                    originalOnEnd.call(this);
                                }

                                $scope.$applyAsync(function () {
                                    if (!signaturePad.isEmpty()) {
                                        // Set _isEmpty flag to false when signature is drawn
                                        signaturePad._isEmpty = false;

                                        // Update the signature photo source
                                        $scope.inspection.checklist.signature_photo_source = signaturePad.toDataURL();

                                        // Clear validation error when signature is drawn
                                        if ($scope.the_form && $scope.the_form.signatureField) {
                                            $scope.the_form.signatureField.$setValidity('required', true);
                                            $scope.the_form.signatureField.$setTouched();
                                        }
                                    }
                                });
                            };
                        }
                    }, 100);
                }
            });

            $scope.resize = function () {
                if (document != null && document.querySelector != null) {
                    $scope.canvas = document.querySelector('canvas.pad');

                    if ($scope.canvas != null && $scope.canvas.offsetWidth != null && $scope.canvas.offsetHeight != null && $scope.canvas.getContext != null) {
                        var ratio = Math.max(window.devicePixelRatio || 1, 1);
                        $scope.canvas.width = $scope.canvas.offsetWidth * ratio;
                        $scope.canvas.height = $scope.canvas.offsetHeight * ratio;
                        $scope.canvas.getContext("2d").scale(ratio, ratio);
                    }
                }
            }

            $scope.$on('$destroy', function () {
                // should maybe give this canvas an id
                var canvasScope = angular.element(document.querySelector('canvas.pad')).scope();
                if (canvasScope) {
                    canvasScope.$destroy();
                }
                angular.element(document.querySelector('canvas.pad')).remove();
                $scope.canvas = undefined;
                canvasScope = undefined;
                $scope.inspection = undefined;
                if ($scope.checklistForm.signature) {
                    $scope.checklistForm.signature.off();
                    $scope.checklistForm.signature = undefined;
                }
            });

            $scope.clearSignature = function () {
                // we need to clear out the values if we select "virtual" for signature, but we don't want to clear it out if its already signed
                if ($scope.inspection.checklist.signature_type_in_person == false && $scope.inspection.checklist.checklist_signed != true) {
                    $scope.inspection.checklist.signature_first_name = null;
                    $scope.inspection.checklist.signature_last_name = null;
                    $scope.inspection.checklist.signature_certification_number = null;
                    $scope.inspection.checklist.signature_photo_source = null;
                    $scope.checklistForm.signature = null;
                }
            }

            Documents.getDocumentsByInspection($scope.inspectionID).then(function (documents) {
                $scope.documents = documents;

                for (var i = 0; i < $scope.documents.length; i++) {
                    $scope.documents[i].link = $rootScope.portalURL + 'controller.cfm?method=publicPortalService.openDocument' + '&documentID=' + $scope.documents[i].id.toUpperCase() + '&code=' + $scope.documents[i].code;
                }
            });
        }])
    ;